import React, { useEffect, useState } from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import Loader from "../../../components/Loader/loader";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Wrapper from "../../../components/UI/Wrapper";
import axios from "axios";
import ExcelExport from "../../../components/ExcelExport/ExcelExport";
import filterIcon from "../../../Icons/filterIcon.png";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import searchIcon from "../../../images/SearchIcon.png";
import "./ShipmentList.css"; // Import the CSS file for styling
import { DateRangePicker } from "react-date-range";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

function ShipmentList() {
  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const navigate = useNavigate();
  const baseAPI = process.env.REACT_APP_API_URL;
  const itemsPerPage = 20;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const [showFilterDiv, setShowFilterDiv] = useState(false);
  const [inputDataValue, setInputDataValue] = useState("");
  const [serviceTypeData, setServiceTypeData] = useState("0");
  const [serviceTypeResponse, setServiceTypeResponse] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState("0");
  const [orderStatusData, setOrderStatusData] = useState("2");
  const [fileStatusData, setFileStatusData] = useState("-2");
  const [totalRecords, setTotalRecords] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [assignToResponse, setAssignToResponse] = useState([]);
  const [assignToLOResponse, setAssignToLOResponse] = useState([]);
  const [assignedto, setAssignedto] = useState("0");
  const [assignedtoLO, setAssignedtoLO] = useState("0");

  const toggleFilterDiv = () => {
    setShowFilterDiv(!showFilterDiv); // This will toggle the visibility of the div
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1) {
      getShipmentListData(newPage);
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
    getShipmentListData();
    getServiceType();
    getEmployeeByDepartment();
    getEmployeeByDepartmentSales();
  }, []);

  const getShipmentListData = () => {
    setIsLoading(true);
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = formatDate(selectionRange.startDate);
    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = '';
      enddate = '';
    }



    axios
      .get(
        `${baseAPI}UserGet/GetShipmentList?searchParam=${inputDataValue}&pageNumber=${currentPage}&pageSize=20&serviceType=0&&orderStatus=2&paymentStatus=0&fileStatus=-2&startDate=${startdate}&endDate=${enddate}&lead_owner=0&ops_coordinator=0`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )

      .then((response) => {
        setUserDetailResponse(response.data.data);
        setTotalRecords(response.data.totalRecords);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  };

  function nextPage(Relocation_ID) {
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/ViewShipmentDetail?Relocation_ID=${encryptedRelocationID}`;
    window.open(url, "_blank");
  }

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      Relocation_ID.toString(),
      key
    ).toString();
    return encodeURIComponent(ciphertext);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
  };



  const handleChangeAttributeInput = (event) => {
    setInputDataValue(event.target.value);
  };

  const handleChangePaymentStatus = (event) => {
    setPaymentStatus(event.target.value);
  };


  const handleServiceType = (event) => {
    setServiceTypeData(event.target.value);
  };

  const handleOrderStatus = (event) => {
    setOrderStatusData(event.target.value);
  };

  const handleFileStatus = (event) => {
    setFileStatusData(event.target.value);
  }

  const handleAssignChange = (e) => {
    setAssignedto(e.target.value);
  };

  const handleAssignLOChange = (e) => {
    setAssignedtoLO(e.target.value);
  };

  function getServiceType() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GetServiceType`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setServiceTypeResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getShipmentData() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    let startdate = formatDate(selectionRange.startDate);
    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = '';
      enddate = '';
    }



    if (storedToken) {
      axios
        .get(
          `${baseAPI}UserGet/GetShipmentList?searchParam=${inputDataValue}&pageNumber=${currentPage}&pageSize=20&serviceType=${serviceTypeData}&orderStatus=${orderStatusData}&paymentStatus=${paymentStatus}&fileStatus=${fileStatusData}&startDate=${startdate}&endDate=${enddate}&lead_owner=${assignedtoLO}&ops_coordinator=${assignedto}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setUserDetailResponse(response.data.data);
            setTotalRecords(response.data.totalRecords);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const resetForm = () => {
    setServiceTypeData("0");
    setInputDataValue("");
    setPaymentStatus("0");
    setOrderStatusData("2");
    setFileStatusData("-1");
    setDateRange("Custom Dates");
    setAssignedto("0");
    setAssignedtoLO('0');

  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'Untouched':
        return 'bg-secondary text-white';
      case 'Open':
        return 'bg-info text-white';
      case 'Executed':
        return 'bg-success text-white';
      case 'Cancelled':
        return 'bg-danger text-white';
      case 'Abandoned':
        return 'bg-warning text-dark';
      default:
        return 'bg-light text-dark';
    }
  };


  const getStatusBadgeClass1 = (status) => {
    switch (status) {
      case 0:
        return 'bg-secondary text-white';
      case 1:
        return 'bg-info text-white';
      case 2:
        return 'bg-success text-white';
      case 3:
        return 'bg-danger text-white';
      case 4:
        return 'bg-warning text-dark';
      default:
        return 'bg-light text-dark';
    }
  };





  const getPaymentTermBadgeClass = (paymentTermStr) => {
    const term = parseInt(paymentTermStr, 10);
    if (isNaN(term)) return 'bg-secondary text-white';

    if (term >= 0 && term <= 20) return 'bg-danger text-white';         // Red
    if (term >= 21 && term <= 40) return 'bg-warning text-dark';       // Orange/Yellow
    if (term >= 41 && term <= 60) return 'bg-info text-white';         // Blue
    if (term >= 61 && term <= 80) return 'bg-primary text-white';      // Dark Blue
    if (term >= 81 && term <= 100) return 'bg-success text-white';     // Green

    return 'bg-light text-dark';
  };

  // const [dateRange, setDateRange] = useState('Custom Dates');

  // const [selectionRange, setSelectionRange] = useState({
  //   startDate: new Date(),
  //   endDate: new Date(),
  //   key: 'selection',
  // });

  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  const [selectionRange, setSelectionRange] = useState({
    startDate: firstDayOfMonth,
    endDate: today,
    key: 'selection',
  });

  // const [dateRange, setDateRange] = useState(
  //   formatDate(firstDayOfMonth) + ' - ' + formatDate(today)
  // );

  const [dateRange, setDateRange] = useState('Custom Dates');


  const togglePicker = () => {
    setDateRange(formatDate(selectionRange.startDate) + ' - ' + formatDate(selectionRange.endDate))
    setIsOpen(!isOpen);
  };



  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }
  const handleSelect = (ranges) => {
    // ranges contains an object with startDate and endDate
    setSelectionRange(ranges.selection);
  };

  const clearDateRange = () => {
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    });
  };



  function formatDateWithTime(dateString) {

    const dateObj = new Date(dateString);
    if (!dateString) return "N/A";
    if (isNaN(dateObj)) return "Invalid date";


    const formatted = dateObj.toLocaleString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).replace(',', '');

    return formatted.replace(' AM', 'AM').replace(' PM', 'PM');
  }


  const statusStyle = {
    0: { text: "Untouched", color: "orange" },
    1: { text: "Open", color: "green" },
    2: { text: "Close", color: "red" },
  };

  const statusMap = {
    0: "Untouched",
    1: "Open",
    2: "Close",
  };

  function getEmployeeByDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=9`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignToResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getEmployeeByDepartmentSales() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=3`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignToLOResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  return (
    <div className="app-container-LeadList">
      <MiniDrawer />
      <div className="container-fluid container-LeadList">
        <div className="country-header">
          <div>
            <h1
              style={{
                fontSize: "24px",
                marginBottom: "1rem",
                lineHeight: "1.7",
              }}
            >
              Shipment List| <HomeOutlinedIcon />{" "}
              <span style={{ fontSize: "20px" }}>&gt; Accounts & Finance</span>
              <span style={{ fontSize: "20px" }}>&gt; Shipment List</span>
            </h1>
          </div>
          <div className="lead-list-button">
            <div
              className="unavalablel-Leadlist"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
            </div>
            <div>
              <p className="icon total-records-icon" style={{

                borderColor: "#C0C6CC",
                border: "1px solid",
                textAlign: "center",
                padding: "10px",
                fontSize: "13px",
                // width: "11rem",
                height: "2.5rem",
                borderRadius: "0.5rem",

              }}> <b> Total Records: </b> <span style={{ color: "#5B489D" }}><b>{totalRecords}</b></span></p>
            </div>
          </div>

        </div>
        <wrapper className="wrapper orderlist">
          <div className="content-container-orderlist">
            <div className="container-fluid" styel={{ marginTop: "3rem" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  className=" headerButton"
                  style={{
                    display: "flex",
                    gap: "5px",
                    justifyContent: "left",
                    width: "82%",
                  }}
                >
                  <div style={{ position: "relative", height: "3rem" }}>
                    <img
                      src={searchIcon}
                      alt="Search"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        width: "16px",
                        height: "16px",
                        zIndex: 1,
                      }}
                    />

                    <input
                      type="text"
                      value={inputDataValue}
                      onChange={handleChangeAttributeInput}
                      // className="form-control optionSize"
                      placeholder="Enter Lead ID"
                      style={{
                        paddingLeft: "30px",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "13px",
                        fontWeight: "bold",
                        marginTop: "6px",
                        position: "relative",
                        width: "8rem",
                      }}
                    />
                  </div>

                  <div>
                    <select
                      id="serviceType"
                      name="serviceType"
                      value={serviceTypeData}
                      onChange={handleServiceType}
                      // className="form-control optionSize"
                      // placeholder="Service Type"
                      style={{
                        marginBottom: "1rem",
                        width: "9.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "13px",
                        fontWeight: "bold",
                        marginTop: "6px",
                      }}
                    >
                      <option value="0">Service Type</option>
                      {serviceTypeResponse !== null ? (
                        serviceTypeResponse.map((item) => (
                          <option value={item.service_type}>
                            {item.ServiceTypeName}
                          </option>
                        ))
                      ) : (
                        <p>empty</p>
                      )}
                    </select>
                  </div>

                  <div>
                    <select
                      id="orderStatus"
                      name="orderStatus"
                      value={orderStatusData}
                      onChange={handleOrderStatus}
                      style={{
                        marginBottom: "1rem",
                        width: "9.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "13px",
                        fontWeight: "bold",
                        marginTop: "6px",
                      }}
                    >
                      <option value="-1">Order Status</option>
                      <option value="0">Untouched</option>
                      <option value="1">Open</option>
                      <option value="2">Executed</option>
                      <option value="3">Cancelled</option>
                    </select>
                  </div>
                  <div>
                    <select
                      id="fileStatus"
                      name="fileStatus"
                      value={fileStatusData}
                      onChange={handleFileStatus}
                      style={{
                        marginBottom: "1rem",
                        width: "9.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "13px",
                        fontWeight: "bold",
                        marginTop: "6px",
                      }}
                    >
                      <option value="-1">Accounting Status</option>
                      <option value="-2" >Today's Task</option>
                      <option value="0">Untouched</option>
                      <option value="1">Open</option>
                      <option value="2">Closed</option>
                    </select>
                  </div>
                  <div>
                    <select
                      name="assignedto"
                      onChange={handleAssignChange}
                      value={assignedto}
                      style={{
                        marginBottom: "1rem",
                        width: "9.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "13px",
                        fontWeight: "bold",
                        marginTop: "6px",
                      }}
                    >
                      <option disabled value="0">
                        Ops Coordinator
                      </option>
                      {assignToResponse.map((item) => (
                        <option value={item.customer_id}>
                          {item.name}
                        </option>
                      ))}
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div>
                    <select
                      name="assignedtoLO"
                      onChange={handleAssignLOChange}
                      value={assignedtoLO}
                      style={{
                        marginBottom: "1rem",
                        width: "9.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "13px",
                        fontWeight: "bold",
                        marginTop: "6px",
                      }}
                    >
                      <option disabled value="0">Lead Owner</option>
                      {assignToLOResponse.map((item) => (
                        <option value={item.customer_id} className={item.is_available ? 'green' : 'black'}>
                          {item.name}
                        </option>
                      ))}
                      <option value="All">All</option>
                    </select>
                  </div>

                  <div>
                    <select
                      id="paymentStatus"
                      name="paymentStatus"
                      value={paymentStatus}
                      onChange={handleChangePaymentStatus}
                      style={{
                        marginBottom: "1rem",
                        width: "9.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "13px",
                        fontWeight: "bold",
                        marginTop: "6px",
                        width: "9.2rem",
                      }}
                    >
                      <option value="0">Payment Status</option>
                      <option value="20">0% - 20%</option>
                      <option value="40">21% - 40%</option>
                      <option value="60">41% - 60%</option>
                      <option value="80">61% - 80%</option>
                      <option value="100">81% - 100%</option>

                    </select>
                  </div>
                  <div>
                    <button style={{
                      marginBottom: "1rem",
                      width: "12rem",
                      height: "2.5rem",
                      borderRadius: "0.5rem",
                      fontSize: "13px",
                      marginTop: "6px",
                    }} onClick={togglePicker}> <b> {dateRange}</b></button>
                    {isOpen && (
                      <div style={{ position: 'absolute', zIndex: 999, border: "solid 1px black", marginLeft: "-13pc", width: "35pc", background: "white" }}>
                        <DateRangePicker
                          ranges={[selectionRange]}
                          onChange={handleSelect}
                        />
                        <button onClick={clearDateRange} style={{
                          marginBottom: "1rem",
                          width: "5rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          position: "relative",
                          top: "1px",
                          left: "22pc",
                          color: "red",
                          border: "none"


                        }}>Reset</button>
                        <button style={{
                          marginBottom: "1rem",
                          width: "7rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          position: "relative",
                          top: "1px",
                          left: "22pc",
                          backgroundColor: "#5B489D",
                          color: "White"

                        }} onClick={togglePicker}>Done</button>
                      </div>
                    )}
                  </div>

                  <div>
                    <div
                      className="fafilterApply"
                      style={{
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      <div
                        className="orderlist-filter"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          marginTop: "6px",
                          width: "8rem",
                        }}
                      >
                        <button onClick={getShipmentData} className="">
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      className="fafilterresetApply"
                      style={{
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      <div
                        className="orderlist-filter-clear"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          marginTop: "6px",
                          width: "8rem",
                          gap: "1px",
                        }}
                      >
                        {/* Clear Filter Button */}
                        <button
                          style={{
                            marginRight: "34px",
                            fontWeight: "600",
                            color: "#F15843",
                          }}
                          onClick={resetForm}
                          className=""
                        >
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div style={{ paddingTop: '15px' }}>
                  <p className="icon total-records-icon" style={{

                    borderColor: "#C0C6CC",
                    border: "1px solid",
                    textAlign: "center",
                    padding: "10px",
                    fontSize: "13px",
                    // width: "11rem",
                    height: "2.5rem",
                    borderRadius: "0.5rem",

                  }}> <b> Total Records: </b> <span style={{ color: "#5B489D" }}><b>{totalRecords}</b></span></p>
                </div> */}
              </div>
            </div>
          </div>
        </wrapper>
        <br />
        <div>
          <div className="sscroll">
            <Wrapper className="leadList">
              <div className="content-container-LeadList">
                {isLoading ? (
                  <Loader />
                ) : (
                  <div className="container-fluid">

                    <div className="headingLeadReport mt-2">
                      <p>Shipment List</p>
                    </div>
                    <div className="leadList">
                      <table
                        style={{ width: "100%", border: "1px solid #DEE2E6" }}
                      >
                        <tr
                          style={{ backgroundColor: "#DEE2E6" }}
                          className="leadListHeading"
                        >
                          <th style={{ color: "#6A6A6A", width: "17%" }}>
                            Customer Details
                          </th>
                          <th style={{ color: "#6A6A6A", width: "23%" }}>
                            Shipment Details
                          </th>
                          <th style={{ color: "#6A6A6A", width: "20%" }}>
                            Pet Details
                          </th>
                          <th style={{ color: "#6A6A6A", width: "17%" }}>
                            Payment & Expense Details
                          </th>
                          <th style={{ color: "#6A6A6A", width: "20%" }}>
                            Coordinator And Status
                          </th>
                          <th style={{ color: "#6A6A6A", width: "3%" }}>
                            Detail
                          </th>
                        </tr>
                        {userDetailResponse &&
                          userDetailResponse?.length > 0 ? (
                          userDetailResponse.map((user, index) => (
                            <tr >
                              <td style={{ color: "#6a6a6a" }}>
                                <table className="leadlist_1 shipment_list">
                                  <tr><td style={{
                                    width: "30%",
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                  }}>Sr.No.</td>
                                    <td style={{ width: "2%" }}>:</td>
                                    <td style={{ width: "68%" }}>
                                      {index + 1}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{

                                        fontWeight: "bold",
                                        color: "#6a6a6a",
                                      }}
                                    >
                                      Lead ID
                                    </td>
                                    <td >:</td>
                                    <td>
                                      {user.Relocation_ID}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Full Name
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.First_Name + (user.Last_Name ? ' ' + user.Last_Name : '')}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Email
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.Email}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Phone No
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.Mobile_No}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Alt Phone No
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.alternate_number}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Origin
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td
                                      style={{ color: "#6a6a6a" }}
                                    >{`${user.Origin_City_Name} , ${user.Origin_State_Name} , ${user.Origin_Country_Name}`}</td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Destination
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td
                                      style={{ color: "#6a6a6a" }}
                                    >{`${user.Destination_City_Name} , ${user.Destination_State_Name} , ${user.Destination_Country_Name}`}</td>
                                  </tr>
                                  <tr><td colSpan={"3"}>&nbsp;</td></tr>

                                </table>
                              </td>
                              <td style={{ color: "#6a6a6a" }}>
                                <table className="leadlist_1 shipment_list">
                                  <tr>
                                    <td
                                      style={{
                                        width: "49%",
                                        fontWeight: "bold",
                                        color: "#6a6a6a",
                                      }}
                                    >
                                      Execution Date
                                    </td>
                                    <td style={{ width: "2%" }}>:</td>
                                    <td style={{ width: "49%" }}>
                                      {formatDateWithTime(user.Execution_Date)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Service Type
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.ServiceTypeName}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Delivery Type
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.delivery_type_name}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Lead Station
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>{ }</td>
                                  </tr>

                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Total Follow Up
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.total_followups}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Follow Up Date & Time
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {formatDateWithTime(user.followUpdatetime)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Next Follow Up Date & Time
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {formatDateWithTime(user.nextfollowUpdatetime)}
                                    </td>
                                  </tr>
                                  <tr><td colSpan={"3"}>&nbsp;</td></tr>
                                  <tr><td colSpan={"3"}>&nbsp;</td></tr>
                                </table>
                              </td>
                              <td style={{ color: "#6a6a6a" }}>
                                <table className="leadlist_1 shipment_list">
                                  <tr>
                                    <td
                                      style={{
                                        width: "46%",
                                        fontWeight: "bold",
                                        color: "#6a6a6a",
                                      }}
                                    >
                                      No. of Pet
                                    </td>
                                    <td style={{ width: "4%" }}>:</td>
                                    <td style={{ width: "55%" }}>
                                      {user.Number_Of_Pets}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Pet Name{" "}
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.Pet_Name}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Pet Type{" "}
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.PetType}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Breed
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.PetBreedType}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Gender
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.pet_gender}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Age
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.Pet_Age}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Behaviour
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.pet_behaviour}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Crate Size
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {`${user.CrateLength}*${user.CrateWidth}*${user.CrateHeight}`}{" "}
                                      inches
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Ch. Weight
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.chargeable_wt}
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td style={{ color: "#6a6a6a" }}>
                                <table className="leadlist_1 shipment_list">
                                  <tr>
                                    <td
                                      style={{
                                        width: "62%",
                                        fontWeight: "bold",
                                        color: "#6a6a6a",
                                      }}
                                    >
                                      Quotation Amount
                                    </td>
                                    <td style={{ width: "4%" }}>:</td>
                                    <td style={{ width: "55%" }}>
                                      {user.Quotation}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Payment Received
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.Token_Payment}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Pending Payment
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.Remaining_Payment}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Expense Amount{" "}
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>{user.total_expense}</td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Gross Profit{" "}
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>{user.GrossProfit}</td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Gross Profit (%){" "}
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>{user.GrossProfitPercent}</td>
                                  </tr>
                                  <tr><td colSpan={"3"}>&nbsp;</td></tr>
                                  <tr><td colSpan={"3"}>&nbsp;</td></tr>
                                  <tr><td colSpan={"3"}>&nbsp;</td></tr>
                                </table>
                              </td>
                              <td style={{ color: "#6a6a6a" }}>
                                <table className="leadlist_1 shipment_list">
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Lead Owner
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      <span > {user.name}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Operation Coordinator
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      <span > {user.Assigned_Coordinator}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Field Coordinator
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      <span > {user.Field_Ops}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Order Status
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      <span className={`badge ${getStatusBadgeClass(user.order_status)}`} style={{ padding: "5px 10px", borderRadius: "5px" }}>
                                        {user.order_status} </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Accounting Status
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {/* {user.File_Submit_in_Accounts} */}

                                      <span className={`badge ${getStatusBadgeClass1(user.shipmentStatus)}`}>
                                        {statusMap[user.shipmentStatus] || "Unknown"} </span>


                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Payment Status (%)
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}>
                                      {user.Pymt_Status && user.Pymt_Status.trim() !== '' ? user.Pymt_Status : 'Pending'}
                                      <span className={`badge ${getPaymentTermBadgeClass(user.Payment_Ter)}`}>
                                        (
                                        {user.Payment_Ter ?? 0}%)
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        color: "#6A6A6A",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Billing Status{" "}
                                    </td>
                                    <td style={{ color: "#6a6a6a" }}>:</td>
                                    <td style={{ color: "#6a6a6a" }}></td>
                                  </tr>
                                  <tr><td colSpan={"3"}>&nbsp;</td></tr>
                                  <tr><td colSpan={"3"}>&nbsp;</td></tr>

                                </table>
                              </td>
                              <td className="" style={{ color: "#6a6a6a" }}>
                                <button
                                  className="text-center"
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    padding: "0px",
                                    margin: "0px",
                                    border: "none",
                                  }}
                                >
                                  <SearchIcon
                                    className="icon"
                                    onClick={() => nextPage(user.Relocation_ID)}
                                    style={{
                                      color: "#6a6a6a",
                                      backgroundColor: "#F1F1F1",
                                      width: "33px",
                                      padding: "7px",
                                      height: "33px",
                                      borderRadius: "5px",
                                    }}
                                  />
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <p>empty</p>
                        )}
                      </table>
                      <nav
                        aria-label="Page navigation"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "1rem",
                        }}
                      >
                        <ul className="pagination">
                          <li className="page-item">
                            <a
                              style={{
                                cursor: "pointer",
                                fontWeight: "bold",
                                color: "#5B489D",
                              }}
                              className="page-link"
                              onClick={() => {
                                handlePageChange(currentPage - 1);
                              }}
                              disabled={currentPage === 1}
                            >
                              Previous
                            </a>
                          </li>

                          <li
                            style={{ backgroundColor: "#5B489D" }}
                            className="page-item active"
                          >
                            <a
                              style={{
                                backgroundColor: "#5B489D",
                                border: "none",
                              }}
                              className="page-link"
                            >
                              {currentPage}
                            </a>
                          </li>
                          <li className="page-item">
                            <a
                              style={{ cursor: "pointer", color: "#5B489D" }}
                              className="page-link"
                              onClick={() => {
                                handlePageChange(currentPage + 1);
                              }}
                              disabled={endIndex >= userDetailResponse?.length}
                            >
                              {currentPage + 1}
                            </a>
                          </li>
                          <li className="page-item">
                            <a
                              style={{
                                cursor: "pointer",
                                color: "#5B489D",
                                fontWeight: "bold",
                              }}
                              className="page-link"
                              onClick={() => {
                                handlePageChange(currentPage + 1);
                              }}
                              disabled={endIndex >= userDetailResponse?.length}
                            >
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                )}
              </div>
            </Wrapper>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShipmentList;
